var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fetch-story',{attrs:{"route":_vm.cms.api_endpoint,"params":{
    sort_by: _vm.cms.api_order_by || null,
    by_uuids: _vm.cms.api_filter || null,
    filter_query: {
      thumbnails: {
        not_in: null,
      },
    },
  },"limit":parseInt(_vm.cms.api_limit) || 0,"offset":parseInt(_vm.cms.api_offset) || 0,"collection":_vm.cms.slides,"entry":"content"},scopedSlots:_vm._u([{key:"default",fn:function({ collection }){return _c('grid',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"html-tag":"section","layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        rows: 'repeat(1, auto)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        rows: 'repeat(1, auto)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__media`],attrs:{"layout":[
        { size: 1, x: 1, width: 12, y: 1, height: 1 },
        { size: 3, x: 1, width: 24, y: 1, height: 1 },
      ]}},[((collection || []).length > 0)?_c('vue-slick-carousel',_vm._b({ref:"carousel",class:`${_vm.name}__carousel`,on:{"afterChange":_vm.onAfterChange,"init":_vm.onInit}},'vue-slick-carousel',{
          slidesToShow: _vm.carousel.slidesToShow,
          arrows: _vm.carousel.arrows,
          infinite: _vm.carousel.infinite,
          mobileFirst: _vm.carousel.mobileFirst,
          lazyLoad: _vm.carousel.lazyLoad,
        },false),_vm._l((_vm.setThumbnail(collection)),function(item,index){return _c('div',{key:index,class:`${_vm.name}__slide`,style:({
            backgroundImage: 'url(' + item.image2.filename + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }),on:{"click":function($event){return _vm.handleClick(item)},"mouseover":function($event){return _vm.pauseAutoplay(true)},"mouseleave":function($event){return _vm.pauseAutoplay(false)}}})}),0):_vm._e()],1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__misc`],staticStyle:{"z-index":"1"},attrs:{"layout":[
        { size: 1, x: 1, width: 12, y: 1, height: 1 },
        { size: 3, x: 1, width: 24, y: 1, height: 1 },
      ]}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"html-tag":"div","layout":[
          {
            size: 1,
            columns: 'repeat(12, 1fr)',
            gap: '6px',
          },
          {
            size: 2,
            columns: 'repeat(24, 1fr)',
            gap: '10px',
          },
        ]}},[(_vm.show)?_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
            { size: 1, x: 1, width: 12 },
            { size: 3, x: 1, width: 24 },
          ]}},_vm._l((_vm.cms.nav),function(item,index){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:index,tag:"component",class:`${_vm.name}__nav`,attrs:{"cms":item,"collection":collection,"carousel":_vm.carousel,"autoplay":_vm.autoplay && !_vm.carousel.paused},on:{"on-next-slide":_vm.onNextSlide,"on-prev-slide":_vm.onPrevSlide}})}),1):_vm._e()],1)],1)],1)}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }